<template lang="pug">
.devices
  //- Barra de navegación
  van-nav-bar(:title='$t("devices.title")')
    van-icon(name='menu', slot='left', @click='openSidenav')

  //- Sección principal
  .main(v-if='linkedAccount.length')
    //- Listado de instalaciones
    .units__installations(v-for='(account, accountKey) in linkedAccount', :key='accountKey')
      //- Fila de instalación
      .units__installations__bar(@click='openManageAccount(account)')
        .units__installations__name {{ $t(`devices.${account.brand}`) }}
        .units__installations__action
          van-icon(name='right')

      //- Fila de dispositivo
      .units__device__bar(
        v-if='account.devices.length',
        v-for='(device, key) in account.devices',
        :key='key',
        @click='openSelectZone(device)'
      )
        .units__device__name
          van-icon.media__figure(name='device')
          span
            | {{ device.name }}
            br(v-if='device.installation')
            span.units__device__label(v-if='device.installation') {{ device.installation }} > {{ device.unit }}
        .units__device__action
          van-icon(name='right')

      .units__device__bar.empty(v-if='!account.devices.length')
        .units__device__name {{ $t("devices.noDevices") }}

    .units__message {{ $t("devices.empty.message") }}

  //- Botón de desvincular una cuenta
  .button-bottom-group(v-if='linkedAccount.length')
    button.button-bottom(@click='openLinkAccount') {{ $t("devices.addThermostat") }}

  //- Mensaje cuando no está disponible esta funcionalidad
  //- .main(v-if="noAvailable")
  //-   .padding
  //-     .addUnit__message.margin-double-bottom.margin-double-top
  //-       .addUnit__message__title {{ $t('devices.noAvailable') }}

  //- Mensaje cuando no hay ninguna instalación
  .main(v-if='!linkedAccount.length || noAvailable')
    .padding
      img.addUnit__img(src='@/assets/img/addDevice.png')

      .addUnit__message.margin-double-bottom.margin-double-top
        .addUnit__message__title {{ $t("devices.import.title") }}
        .margin-halve-top 1. {{ $t("devices.import.message1") }}
        .margin-halve-top 2. {{ $t("devices.import.message2") }}
        small.block.margin-top.text-danger(v-if='noAvailable') {{ $t("devices.noAvailable") }}
        small.block.margin-top.text-danger(v-else) {{ $t("devices.import.warning") }}

      button.van-button.van-button--primary.van-button--large(
        @click='openLinkAccount',
        v-if='!noAvailable'
      )
        | {{ $t("devices.addThermostat") }}

  //- Modal para vincular cuentas de terceros
  van-popup.van-popup--full(position='right', :value='showLinkAccount', :overlay='false')
    AddDevice(v-if='showLinkAccount', :accounts='accounts', @close='hideLinkAccount')

  //- Modal para desvincular una cuenta de terceros
  van-popup.van-popup--full(position='right', :value='showManageAccount', :overlay='false')
    ManageAccount(v-if='showManageAccount', :account='account', @close='hideManageAccount')

  //- Modal para modificar un dispositivo
  van-popup.van-popup--full(position='right', :value='showSelectZone', :overlay='false')
    SelectZone(v-if='showSelectZone', :device='device', @close='hideSelectZone')
</template>

<script>
import i18n from '@/locales/i18n';
import DevicesService from '@/services/devices.service';
import { IS_PRODUCTION, DEVICES } from '@/app.config';
import { mapGetters, mapActions } from 'vuex';
import AddDevice from '@/components/Devices/AddDevice.vue';
import ManageAccount from '@/components/Devices/ManageAccount.vue';
import SelectZone from '@/components/Devices/SelectZone.vue';
import { hasProp } from '@/utils/validate.utils';
import { TokenService } from '@/services/storage.service';
import OpenLinkMixin from '@/mixins/OpenLink.mixin';

export default {
  components: { AddDevice, ManageAccount, SelectZone },
  data() {
    return {
      account: null,
      accounts: [],
      linkedAccount: [],
      isLoading: false,
      devicesError: null,
      showLinkAccount: false,
      showManageAccount: false,
      showSelectZone: false,
      device: null,
      noAvailable: false,
      isProduction: IS_PRODUCTION,
      timeout: 0,
    };
  },

  watch: {
    async installations(newValue, oldValue) {
      console.log('watch installations ================>');
      let reload = false;

      if (Object.keys(oldValue).length === 0 && oldValue.constructor === Object) return;

      Object.keys(newValue).forEach(installationID => {
        Object.keys(newValue[installationID].devices).forEach(deviceID => {
          const oldValueDevice = oldValue[installationID].devices[deviceID];
          const newValueDevice = newValue[installationID].devices[deviceID];
          // eslint-disable-next-line prettier/prettier
          const oldLinkDeviceID = hasProp(oldValueDevice, 'link_deviceID')
            ? oldValueDevice.link_deviceID
            : null;
          // eslint-disable-next-line prettier/prettier
          const newLinkDeviceID = hasProp(newValueDevice, 'link_deviceID')
            ? newValueDevice.link_deviceID
            : null;

          console.log('device', deviceID);
          console.log(oldLinkDeviceID);
          console.log(newLinkDeviceID);

          if (oldLinkDeviceID !== newLinkDeviceID) reload = true;
        });
      });

      if (reload) await this.getDevices();
    },
  },

  computed: {
    ...mapGetters({
      getInstallations: 'unitsModule/getInstallations',
      appMode: 'globalModule/getAppMode',
    }),

    /**
     * Devuelve todas las instalaciones
     */
    installations() {
      return this.getInstallations();
    },
  },
  mixins: [OpenLinkMixin],
  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
      clearError: 'globalModule/cleanError',
    }),

    /**
     * Obtiene un listado de dispositivos de terceros
     */
    async getDevices() {
      try {
        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });
        setTimeout(async () => {
          await this.getThirdPartyDevices();
          this.$toast.clear();
        }, this.timeout);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Obtiene un listado de dispositivos de terceros
     */
    async getThirdPartyDevices() {
      try {
        console.log('getDevices');
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;
        // console.log('Show toast in getThirdPartyDevices');
        // Muestro el loader
        // this.$toast.loading({
        //   duration: 0,
        //   mask: true,
        //   message: this.$i18n.t('general.loading'),
        // });

        // Inicializo valores
        this.isLoading = true;
        this.devicesError = null;
        // this.linkedAccount = [];
        // this.nonotLinkedAccount = [];

        // Realizo la peticiones en paralelo, envolviendo el map en promesa para hacerlo asíncrono
        await new Promise(async resolve => {
          const promises = DEVICES.map(device => DevicesService.getDevices(device));
          this.accounts = await Promise.all(promises);
          resolve();
        });
        this.linkedAccount = this.accounts.filter(account => account.devices);

        // compruebo si tengo que relinkar alguna
        const accountRelink = this.accounts.find(account => account.relink === true);
        // this.$toast.clear();
        this.isLoading = false;
        if (accountRelink !== undefined) {
          this.$toast.clear();
          this.isLoading = false;
          console.log('Muestro popup de relink');
          this.$dialog
            .confirm({
              // eslint-disable-next-line prettier/prettier
              title: `${this.$i18n.t(`devices.${accountRelink.brand}`)} - ${this.$i18n.t(
                'devices.oauthUnlinked.title'
              )}`,
              message: this.$i18n.t('devices.oauthUnlinked.otherMessage'),
              cancelButtonText: this.$i18n.t('devices.unlinkAccount'),
              confirmButtonText: this.$i18n.t('devices.oauthUnlinked.relink'),
              className: 'devicesFallback',
            })
            .then(async () => {
              //
              // this.linkDevice(installationID, unitMac, true);
              this.isLoading = true;
              const result = await DevicesService.linkAccount(accountRelink.brand);
              const redirectUri = result.redirect_uri;
              const clientId = result.client_id;
              const token = TokenService.getToken('token');

              let url = '';

              // Preparo el link
              if (accountRelink.brand === 'honeywell') {
                url = `https://api.honeywell.com/oauth2/authorize?response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}&state=${token}`;
              } else if (accountRelink.brand === 'ecobee') {
                const scope = result.scope;
                // url = `https://api.ecobee.com/authorize?response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}&scope=${scope}&state=${token}`;
                url = `https://api.ecobee.com/authorize?response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}&scope=${scope}&state=${token}&ecobee_type=jwt`;
              } else if (accountRelink.brand === 'nest') {
                url = `${redirectUri}&state=${token}`;
              }

              this.openLinkMixin(url, this.exitCallback);
            })
            .catch(async () => {
              // Realizo la petición
              this.isLoading = true;
              await DevicesService.unlinkAccount(accountRelink.brand)
                .then(() => {
                  // Confirmo los cambios
                  this.isLoading = false;
                  this.$dialog
                    .alert({
                      title: this.$i18n.t('devices.unlinkAccountSuccess.title'),
                      message: this.$i18n.t('devices.unlinkAccountSuccess.message'),
                    })
                    .then(() => {
                      this.exitCallback();
                    });
                })
                .catch(() => {
                  this.isLoading = false;
                  this.$dialog
                    .alert({
                      title: this.$i18n.t('errors.default.title'),
                      message: this.$i18n.t('errors.default.message'),
                    })
                    .then(() => {
                      this.exitCallback();
                    });
                });
            });
        }
        // this.linkedAccount = result.filter(account => account.devices);
        // this.notLinkedAccount = result.filter(account => !account.devices);
      } catch (error) {
        this.$toast.clear();
        // eslint-disable-next-line prettier/prettier
        if (
          error.message === 'Error: Network Error' ||
          error.message === 'Error: Request failed with status code 404'
        ) {
          setTimeout(() => {
            this.clearError();
            this.noAvailable = !this.isProduction && this.appMode !== 'PROD';
          }, 100);
        } else {
          this.$toast.fail({
            mask: true,
            message: i18n.t('general.errors.default.message'),
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    async exitCallback() {
      console.log('Exit');
      await this.getDevices();
    },

    close(reload) {
      this.$emit('close', reload);
    },

    /**
     * Muestra el modal para vincular una cuenta
     */
    openLinkAccount(account) {
      this.linkAccountData = account;
      this.showLinkAccount = true;
    },

    /**
     * Oculta el modal para vincular una cuenta
     */
    async hideLinkAccount(reload) {
      console.log('hideLinkAccount', reload);
      this.linkAccountData = null;
      this.showLinkAccount = false;

      if (reload) {
        await this.getDevices();
      }
    },

    openSelectZone(device) {
      this.device = device;
      this.showSelectZone = true;
    },

    async hideSelectZone(reload) {
      this.device = null;
      this.showSelectZone = false;

      if (reload) {
        await this.getDevices();
      }
    },

    openManageAccount(account) {
      this.account = account;
      this.showManageAccount = true;
    },

    async hideManageAccount(reload) {
      this.account = null;
      this.showManageAccount = false;

      if (reload) {
        await this.getDevices();
      }
    },

    async onPageResume() {
      console.log('onPageResume');
      // Delay 1 s the backend requests
      this.timeout = 1000;
      this.isLoading = false;
      this.showSelectZone = false;
      this.showLinkAccount = false;
      this.showManageAccount = false;
      await this.getDevices();
    },
  },

  async created() {
    await this.getDevices();
    document.addEventListener('AppResume', this.onPageResume);
  },

  destroyed() {
    document.removeEventListener('AppResume', this.onPageResume);
  },
};
</script>
